import React from "react";
import styles from "./menu-lateral-btn.module.css";

type Props = {
  onHandleTab: (tab: string) => string;
  onChangeSelected: (selected: string) => void;
  icon: JSX.Element;
  title: string;
};

const BtnMenu = ({ onHandleTab, onChangeSelected, icon, title }: Props) => {
  return (
    <li className={onHandleTab(title)} onClick={() => onChangeSelected(title)}>
      <div className={styles.btnContainer}>
        {icon}
        <span>{title}</span>
      </div>
    </li>
  );
};

export default BtnMenu;
